/** Rubrique Modes de vente et coefficients : règles éditables + exemple à 14,50 € + recalcul. */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { parametresApi } from '../../../services/api';
import { Button, Spinner, Card } from '../../../components/ui/kit';

const euro = (n) => (n === null || n === undefined ? '—' : `${Number(n).toLocaleString('fr-FR', { maximumFractionDigits: 2 })} €`);

export default function ModesVente() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ['sale-modes'], queryFn: parametresApi.saleModes });
  const save = useMutation({ mutationFn: (modes) => parametresApi.saveSaleModes(modes), onSuccess: () => { toast.success('Règles enregistrées'); qc.invalidateQueries({ queryKey: ['sale-modes'] }); } });
  const recompute = useMutation({ mutationFn: () => parametresApi.recompute(), onSuccess: (d) => toast.success(`${d.updated} prix recalculés`) });
  if (isLoading) return <Spinner />;

  const modes = data.sale_modes;
  const ex = data.example;
  const setCoef = (i, field, value) => {
    const next = modes.map((m, j) => (j === i ? { ...m, [field]: value === '' ? 0 : Number(value) } : m));
    save.mutate(next);
  };

  return (
    <div className="max-w-[820px]">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-title text-3xl">Modes de vente et coefficients</h2>
        <Button variant="secondary" onClick={() => recompute.mutate()} disabled={recompute.isPending} data-testid="recompute-btn"><RefreshCw className={`w-4 h-4 ${recompute.isPending ? 'animate-spin' : ''}`} /> Recalculer les prix non forcés</Button>
      </div>
      <p className="text-[13px] text-n600 mb-3">Exemple pour un achat à <strong>{euro(data.example_purchase)}</strong></p>
      <Card className="overflow-hidden">
        <table className="w-full text-[13.5px]" data-testid="sale-modes-table">
          <thead><tr className="text-left kicker"><th className="py-2.5 px-3">Mode</th><th className="py-2.5 px-3">Règle</th><th className="py-2.5 px-3 text-right">Coef. / remise</th><th className="py-2.5 px-3 text-right">Exemple</th></tr></thead>
          <tbody>
            {modes.map((m, i) => (
              <tr key={m.key} className="hair-t" data-testid={`mode-${m.key}`}>
                <td className="py-2.5 px-3 font-medium">{m.label}</td>
                <td className="py-2.5 px-3 text-n600">
                  {m.type === 'coef' && `Prix d'achat × coef, arrondi ${m.round === 'euro_sup' ? '€ sup.' : '€'}`}
                  {m.type === 'from_table' && `Prix table − remise (−${m.qty_discount}€ dès ${m.qty_threshold} btl)`}
                  {m.type === 'glass' && `Prix table ÷ ${m.coef} + ${m.add}€ · 75 cl`}
                  {m.type === 'cost' && 'Coût (prix d\'achat), hors CA'}
                </td>
                <td className="py-2.5 px-3 text-right">
                  {m.type === 'coef' && <input type="number" step="0.1" className="vd-input h-8 w-20 text-right" defaultValue={m.coef} onBlur={(e) => setCoef(i, 'coef', e.target.value)} data-testid={`coef-${m.key}`} />}
                  {m.type === 'from_table' && <input type="number" className="vd-input h-8 w-20 text-right" defaultValue={m.discount} onBlur={(e) => setCoef(i, 'discount', e.target.value)} data-testid={`coef-${m.key}`} />}
                  {m.type === 'glass' && <input type="number" step="0.1" className="vd-input h-8 w-20 text-right" defaultValue={m.coef} onBlur={(e) => setCoef(i, 'coef', e.target.value)} data-testid={`coef-${m.key}`} />}
                  {m.type === 'cost' && <span className="text-n400">—</span>}
                </td>
                <td className="py-2.5 px-3 text-right nums font-medium" data-testid={`example-${m.key}`}>{euro(ex[m.key])}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
